import { render, staticRenderFns } from "./PageDiscounts.vue?vue&type=template&id=22ae58bb&"
import script from "./PageDiscounts.vue?vue&type=script&lang=js&"
export * from "./PageDiscounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports